import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRelatedPosts } from "../../features/relatedPosts/relatedPostsSlice";
import RelatedPostItem from "./RelatedPostItem";

export default function RelatedPosts({ tags, postId }) {
  const dispatch = useDispatch();
  const { relatedPosts } = useSelector(state => state.relatedPosts)

  useEffect(() => {
    dispatch(fetchRelatedPosts({ tags, postId }))
  }, [dispatch, tags, postId])
  
  return (
    <aside>
      <h4 className="mb-4 text-xl font-medium" id="lws-relatedPosts">Related Posts</h4>
      <div className="space-y-4 related-post-container">
        {relatedPosts?.length ?
          relatedPosts.map(post=><RelatedPostItem post={post} key={post.id} />)
          :
          <div>Related Posts Not Found</div>
        }
      </div>
    </aside>

  )
}